import { Component, Input, Output, EventEmitter, HostBinding, input } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-ice-icon-button',
  templateUrl: './ice-icon-button.component.html',
  styleUrls: ['./ice-icon-button.component.scss'],
  imports: [NgStyle, MatIcon],
})
export class IceIconButtonComponent {
  testId = input.required<string>();
  ariaLabel = input<string>();
  @Input({ required: true }) iconName: IconNames;
  @Input({ required: false }) @HostBinding('style.width') @HostBinding('style.height') size = '24px';
  @Output() clicked = new EventEmitter<void>();
}
